import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const FilterControls = ({ 
  filters, 
  onFilterChange, 
  onClearFilters,
  authors,
  totalCount,
  filteredCount 
}) => {
  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'published', label: 'Published' },
    { value: 'draft', label: 'Draft' }
  ];

  const authorOptions = [
    { value: 'all', label: 'All Authors' },
    ...authors?.map(author => ({ value: author, label: author }))
  ];

  const hasActiveFilters = 
    filters?.status !== 'all' || 
    filters?.author !== 'all' || 
    filters?.dateFrom || 
    filters?.dateTo || 
    filters?.search;

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6">
      <div className="flex flex-col lg:flex-row lg:items-end gap-4 mb-4">
        <div className="flex-1 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <Input
            type="search"
            placeholder="Search posts..."
            value={filters?.search}
            onChange={(e) => onFilterChange('search', e?.target?.value)}
            className="w-full"
          />
          
          <Select
            options={statusOptions}
            value={filters?.status}
            onChange={(value) => onFilterChange('status', value)}
            placeholder="Filter by status"
          />
          
          <Select
            options={authorOptions}
            value={filters?.author}
            onChange={(value) => onFilterChange('author', value)}
            placeholder="Filter by author"
          />
          
          <div className="flex gap-2">
            <Input
              type="date"
              value={filters?.dateFrom}
              onChange={(e) => onFilterChange('dateFrom', e?.target?.value)}
              placeholder="From date"
              className="flex-1"
            />
            <Input
              type="date"
              value={filters?.dateTo}
              onChange={(e) => onFilterChange('dateTo', e?.target?.value)}
              placeholder="To date"
              className="flex-1"
            />
          </div>
        </div>
        
        {hasActiveFilters && (
          <Button
            variant="outline"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
            iconSize={16}
          >
            Clear Filters
          </Button>
        )}
      </div>
      <div className="flex items-center justify-between text-sm">
        <span className="text-muted-foreground">
          Showing {filteredCount} of {totalCount} posts
        </span>
        {hasActiveFilters && (
          <span className="text-primary font-medium">
            {filteredCount} filtered results
          </span>
        )}
      </div>
    </div>
  );
};

export default FilterControls;